module.exports = __webpack_public_path__ + "img/contact.763de2a0.svg";